import { render, staticRenderFns } from "./edit-tenant.vue?vue&type=template&id=e28184f0&"
import script from "./edit-tenant.vue?vue&type=script&lang=ts&"
export * from "./edit-tenant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-tenant.vue"
export default component.exports